export interface BatchCollectionMgmtListByCollectionRequest {
  acceptDateFrom: string
  acceptDateTo: string
  status: string
  holdingBranch: string
  rdoOutputType: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtListByCollectionRequestToJSON(
  value: BatchCollectionMgmtListByCollectionRequest
): any {
  return {
    accept_date_from: value.acceptDateFrom,
    accept_date_to: value.acceptDateTo,
    status: value.status,
    holding_branch: value.holdingBranch,
    rdo_output_type: value.rdoOutputType,
    memo: value.memo,
    batch_type: value.batchType
  }
}
